import { Box } from "@mui/material";
import { SubscriptionCards } from "components/billing/subscription-cards";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { UsageGraph } from "../usage/usage-graph";

export const Dashboard = () => {
  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "24px",
        height: "700px",
        position: "relative",
      }}
    >
      <SubscriptionCards />

      <UsageGraph />
    </Box>
  );
};
